import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VisualizationContainerComponent } from './component/visualization-container.component';
import { LessonCardModule } from '../lesson-card/lesson-card.module';
import { LessonFlipModuleModule } from '../lesson-flip-module/lesson-flip-module.module';
import { FormsModule } from '@angular/forms';

@NgModule({
	declarations: [VisualizationContainerComponent],
	imports: [
		CommonModule,
		LessonCardModule,
		LessonFlipModuleModule,
		FormsModule
	],
	exports: [VisualizationContainerComponent]
})
export class VisualizationContainerModule {}
